import React from 'react';
import { connect } from "react-redux";
import { deviceInfo } from "../redux/actions";
import ClosedPage from "./ClosedPage/ClosedPage";
import VideoPage from "./VideoPage/VideoPage";
import StartPage from "./StartPage/StartPage";
import EndPage from './EndPage/EndPage';
import { NUMBER_OF_VIDEOS, IS_CLOSED } from '../services/config';
import Device from 'react-device';

const Root = ({ videotest, onChange }) => (
    <div>
        {IS_CLOSED ? (<ClosedPage />) :
            (<div>
                <Device onChange={onChange} />
                {videotest.get('progress') === 0 ?
                    (<StartPage />)
                    : videotest.get('progress') > NUMBER_OF_VIDEOS ?
                        <EndPage /> : <VideoPage />
                }
            </div>
            )

        }
    </div>
);

const mapStateToProps = state => ({
    videotest: state.get('videotest')
});

const mapDispatchToProps = dispatch => {
    return {
        onChange: (info) => dispatch(deviceInfo(info)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Root);



// WEBPACK FOOTER //
// ./src/components/Root.js